// src/stone/illustrations/AnimationPhoneIllustration.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var AnimationPhoneIllustration = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 80 96",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "m.253 22.397 3.162 12.968.647 2.648.343 1.411 12.162 49.857c1.155 4.727 5.911 7.622 10.628 6.464l34.61-8.48c4.717-1.152 7.604-5.921 6.45-10.649L51.94 9.736c-1.152-4.725-5.908-7.621-10.625-6.467L23.209 7.707 6.706 11.749C1.99 12.907-.898 17.674.253 22.397"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#42EC9A",
          d: "m.253 22.397 3.162 12.968 17.153-15.576 7.475-6.793c-.897-.617-2.705-2.673-4.832-5.288L6.706 11.75C1.99 12.907-.898 17.674.253 22.397M4.062 38.011l.343 1.412 14.84-13.337c.257-.236.17-.707-.066-.913-.29-.242-.65-.169-.912.066-1.64 1.481-3.294 2.962-4.934 4.44z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#00A868",
          d: "m36.776 93.396 37.484-9.184c4.037-.99 6.51-5.072 5.523-9.118L62.869 5.753c-.987-4.047-5.06-6.525-9.098-5.535L16.287 9.402c-4.037.989-6.51 5.071-5.525 9.118l16.914 69.34c.99 4.047 5.063 6.525 9.1 5.536"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#42EC9A",
          d: "m32.427 81.49 40.21-9.852L58.1 12.053l-40.209 9.852z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#FCFCFC",
          stroke: "#FCFCFC",
          d: "m57.733 12.658 14.3 58.613-4.308 1.056-14.3-58.614z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "M36.484 12.614a1.84 1.84 0 0 0 1.836-1.841c0-1.017-.822-1.84-1.837-1.84a1.84 1.84 0 0 0-1.836 1.84c0 1.017.822 1.84 1.837 1.84"
        }
      )
    ]
  }
);
var AnimationPhoneIllustration_default = AnimationPhoneIllustration;

export {
  AnimationPhoneIllustration,
  AnimationPhoneIllustration_default
};
